import { PremiumFeatureRoute, TryPremiumFeature } from '@cast/shared-trial-ui';

import { getDocsLink } from '@cast/utils';

export const PremiumAutoscalerRoute = () => (
  <PremiumFeatureRoute
    paywall={
      <TryPremiumFeature
        name="Autoscaler"
        docs={{
          link: getDocsLink('docs_autoscaler'),
        }}
      />
    }
  />
);
